import i18n from 'modules/core/lib/i18n'

import { PayrollStatus } from 'modules/payroll_bundle/lib/enums'

export const getDashboardButtonCta = (
  status: PayrollStatus,
  canEditSupplements: boolean,
  canSeeCompanyResults: boolean
) => {
  if (status === PayrollStatus.PREPARATION && canEditSupplements) {
    return i18n.t(
      'payroll_bundle.payroll_dashboard.regular_cycle_summary.action_text.start_regular_payroll'
    )
  }

  if (canEditSupplements || canSeeCompanyResults) {
    return i18n.t(
      'payroll_bundle.payroll_dashboard.regular_cycle_summary.action_text.continue_regular_payroll'
    )
  }

  if (status === PayrollStatus.PAID && canSeeCompanyResults) {
    return i18n.t(
      'payroll_bundle.payroll_dashboard.regular_cycle_summary.action_text.manage_results'
    )
  }

  return i18n.t(
    'payroll_bundle.payroll_dashboard.regular_cycle_summary.action_text.see_supplements'
  )
}

/**
 * @deprecated we display phases now, not statuses
 */
export const getStatusStepTitle = (status: PayrollStatus) => {
  switch (status) {
    case PayrollStatus.PREPARATION:
      return i18n.t('payroll_bundle.payroll_dashboard.regular_cycle_summary.steps_text.preparing')
    case PayrollStatus.SUPPLEMENTS_DEFINITION:
      return i18n.t('payroll_bundle.payroll_dashboard.regular_cycle_summary.steps_text.defining')
    case PayrollStatus.UNDER_REVIEW:
      return i18n.t('payroll_bundle.payroll_dashboard.regular_cycle_summary.steps_text.reviewing')
    case PayrollStatus.PAYROLL_CALCULATION:
      return i18n.t('payroll_bundle.payroll_dashboard.regular_cycle_summary.steps_text.calculating')
    default:
      return i18n.t(
        'payroll_bundle.payroll_dashboard.regular_cycle_summary.steps_text.managing_results'
      )
  }
}
